import React, { useContext, useEffect, useState } from 'react';
import {
  ShoppingCart, LogOut, ShoppingBag, Settings, PhoneCall
} from 'lucide-react';
import { CartContext } from '../CartContext';

export default function Navbar({ user, setPage, onLogout }) {
  const { itemCount, totalQuantity } = useContext(CartContext);
  const [companyName, setCompanyName] = useState('Shop');
  const [showModal, setShowModal] = useState(false);
  const [companyDetails, setCompanyDetails] = useState(null);

  useEffect(() => {
    fetch('/config.json')
      .then(res => res.json())
      .then(data => setCompanyName(data.CompanyName || 'Shop'))
      .catch(() => setCompanyName('Shop'));
  }, []);

  const handleContactClick = () => {
    setShowModal(true);
    if (!companyDetails) {
      fetch('https://posservice.revampapps.com/CompanyDetailsAPI?user=admin')
        .then(res => res.json())
        .then(data => {
          const info = data?.CompanyDetailsAPIjs?.Table?.[0];
          setCompanyDetails(info || null);
        })
        .catch(err => {
          console.error('Failed to fetch contact details:', err);
          setCompanyDetails(null);
        });
    }
  };

  return (
    <>
      <header className="bg-white/80 backdrop-blur-md shadow-sm sticky top-0 z-20">
        <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex-shrink-0">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (user) setPage('products');
                }}
                className="flex items-center space-x-3 text-2xl font-bold text-gray-900 transition-transform duration-300 hover:scale-105"
              >
                <ShoppingBag className="h-8 w-8 text-teal-600" />
                <span className="hidden sm:inline">{companyName}</span>
              </a>
            </div>

            <div className="flex items-center space-x-3 sm:space-x-5">
              <button
                onClick={() => setPage('home')}
                className="text-gray-600 hover:text-teal-600 font-medium hidden sm:block px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
              >
                Home
              </button>

              {user && (
                <button
                  onClick={() => setPage('products')}
                  className="text-gray-600 hover:text-teal-600 font-medium hidden sm:block px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  Florals
                </button>
              )}

              {user && (
                <button
                  onClick={() => setPage('cart')}
                  className="relative text-gray-600 hover:text-teal-600 p-2 rounded-full hover:bg-gray-100 transition-colors"
                >
                  <ShoppingCart className="h-6 w-6" />
                  {totalQuantity > 0 && (
                    <span className="absolute -top-1 -right-1 bg-teal-500 text-white text-[10px] font-semibold rounded-full px-1.5 py-0.5 flex items-center justify-center border-2 border-white min-w-[30px] h-5">
                      {itemCount}/{totalQuantity}
                    </span>
                  )}
                </button>
              )}


              {/* Contact Us Button */}
              <button
                onClick={handleContactClick}
                className="text-gray-600 hover:text-teal-600 p-2 rounded-full hover:bg-gray-100 transition-colors"
                title="Contact Us"
              >
                <PhoneCall className="h-6 w-6" />
              </button>
              {/* 
              <button
                onClick={() => setPage('setup')}
                className="text-gray-600 hover:text-teal-600 p-2 rounded-full hover:bg-gray-100 transition-colors"
                title="App Key Setup"
              >
                <Settings className="h-6 w-6" />
              </button> */}

              {user ? (
                <div className="flex items-center space-x-2">
                  <span className="text-gray-700 hidden md:block">
                    Hi, {user.customer}/{user.name}
                  </span>
                  <button
                    onClick={onLogout}
                    className="flex items-center space-x-2 bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-lg transition-all duration-300 shadow-sm hover:shadow-md"
                  >
                    <LogOut className="h-5 w-5" />
                  </button>
                </div>
              ) : (
                <span className="text-gray-700 font-medium">Welcome</span>
              )}
            </div>
          </div>
        </nav>
      </header>

      {/* Contact Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/40 z-40 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-6 relative">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-red-700 text-lg"
            >
              ✕
            </button>

            <h2 className="text-4xl text-center font-bold mb-4 text-teal-700">Contact Us</h2>

            {companyDetails ? (
              <div className="space-y-3 text-gray-900">
                <p><strong></strong> {companyDetails.Comname}</p>
                <p><strong></strong> {companyDetails.PropName}</p>
                <p><strong></strong> {companyDetails.Address1}</p>
                <p><strong></strong> {companyDetails.Address2}</p>
                <p><strong></strong> {companyDetails.City} ,  {companyDetails.State} - {companyDetails.Pincode}</p>
                <p><strong></strong> {companyDetails.Phone},{companyDetails.Mobile}</p>
                <p><strong></strong> </p>
                <p><strong>Email:</strong> {companyDetails.Email}</p>
              </div>
            ) : (
              <p className="text-red-600">Unable to load contact details. Please try again later.</p>
            )}
          </div>
        </div>
      )}
    </>
  );
}
